import React from "react";
import PropTypes from "prop-types";

export default function CardContentButtons({ buttons }) {
  return (
    <div className="slds-grid" style={{gap: "12px"}}>
      {buttons.map((btn, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={i} style={{width: "100%"}}>
          {btn}
        </div>
      ))}
    </div>
  );
}

const { arrayOf, node } = PropTypes;

CardContentButtons.propTypes = {
  buttons: arrayOf(node).isRequired,
  contentType: String.isRequired
};
